module.exports = __webpack_public_path__ + "static/img/contact01.91e3e2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/contact01.jpg
// module id = J+rr
// module chunks = 1